import React, { useContext, useEffect, useState } from 'react'
import { getCurrencies } from 'helpers/api'

import InputCalculateMontantEnvoyer from 'components/InputCalculateMontantEnvoyer'
import ContainerTransfer from './containerTransfer'
import UserContext from 'contexts/UserContext'
import { SearchPromoCodes } from 'requests/transfer'
import transferBeneficiaryContext from 'contexts/transferBeneficiaryContext'
import { CalculatorDetails } from 'requests/user'
import IconOpen from '../../assets/plus.svg'
import InputSelectComponent from 'components/inputSelectComponent'

interface props {
  setCurrencyToTND: (value: number) => void
  com: number
  setCom: (value: number) => void
  taux: number
  setTaux: (value: number) => void
  setDepartureCurrencyId: (value: string) => void
  setDestinationCurrencyId: (value: string) => void
  setNumStep: (value: number) => void
  euroValue: number
  setEuroValue: (value: number) => void
  dinarValue: number
  setDinarValue: (value: number) => void
  // setChoisirModePayment: (value: number) => void
  paymentMode: any
  setPaymentMode: (value: string) => void
  promoCode: any
  setPromoCode: (value: string) => void
  pathCode: any
  valuePays: any
  setValuePays: (value: any) => void
  functionTracks: any
  setCounty?: (val: string) => void
}
interface intervalCommission {
  crossedOutValue?: number
  value: number
  minAmount: number
  maxAmount: number
}

const Montant: React.FC<props> = ({
  setCurrencyToTND,
  com,
  setCom,
  taux,
  setTaux,
  setDepartureCurrencyId,
  setDestinationCurrencyId,
  setNumStep,
  euroValue,
  setEuroValue,
  dinarValue,
  setDinarValue,

  // setChoisirModePayment,
  paymentMode,
  setPaymentMode,
  promoCode,
  setPromoCode,
  pathCode,
  valuePays,
  setValuePays,
  functionTracks,
  setCounty,
}) => {
  const { user } = useContext(UserContext)

  const number = parseInt(pathCode)
  const { TransferData, setTransferData } = useContext(transferBeneficiaryContext)

  const [isOpenLien, setIsOpenLien] = useState(false)

  const [successCode, setSuccessCode] = useState(false)
  const [successCodeError, setSuccessCodeError] = useState(false)

  const [isCalculEuro, setIsCalculEuro] = useState<boolean>()
  const [isCalculDinar, setIsCalculDinar] = useState<boolean>(true)
  const [selectedOptionLien, setSelectedOptionLien] = useState(
    // pathCode === '1' ? 'Virement instantané' : TransferData?.selectedOptionLien || 'Carte Bancaire',
    TransferData?.selectedOptionLien
      ? TransferData?.selectedOptionLien
      : pathCode === '1'
        ? 'Virement instantané'
        : 'Carte Bancaire',
  )

  const [intervalComm, setIntervalComm] = useState<intervalCommission[] | null>(null)
  const [isBonus, setIsBonus] = useState(0)
  const [service, setService] = useState('')
  const [openCodePromotionnel, setOpenCodePromotionnel] = useState(false)
  const [error, setError] = useState(false)
  const [payCode, setPaysCode] = useState('')
  const [crossedOutValue, setCrossedOutValue] = useState<number | null>(null)

  const optionsLien = [
    { index: 0, code: 'cb', value: 'Carte Bancaire' },
    { index: 1, code: 'pi', value: 'Virement instantané' },
  ]

  const pathTarnsfert = pathCode == 1 ? 'bank_account' : pathCode == 2 ? 'digital wallet' : 'cash_pickup'
  //code promo
  const handleChange = (e: any) => {
    const inputValue = e.target.value
    setPromoCode(inputValue)
  }

  const handleEuroChangeMessage = (montant: any) => {
    if (montant >= 15 && montant < 5001) {
      setError(false)
      setEuroValue(montant)
    } else {
      setError(true)
    }
  }

  const handleEuroChange = (euroInputValue: any) => {
    setEuroValue(euroInputValue)
    setIsCalculDinar(true)
    setIsCalculEuro(false)
  }

  const handleDinarChange = (dinarInputValue: any) => {
    setDinarValue(dinarInputValue)
    setCurrencyToTND(dinarInputValue)
    setIsCalculDinar(false)
    setIsCalculEuro(true)
  }

  useEffect(() => {
    if (pathCode === '0') setService('isCash')
    else if (pathCode === '1') setService('isBank')
    else if (pathCode === '2') setService('isWallet')

    setNumStep(0)

    if (TransferData?.currentPath === '/beneficiary') {
      setValuePays({ value: TransferData?.valuePays })
    }
  }, [pathCode, user])

  useEffect(() => {
    // if(!currenciessList) return
    // if(!paymentMode) return
    //   if (!valuePays.value || !user?.user?.address?.country?.code) return

    const getDetailsUser = async () => {
      try {
        const newSelectedOption = pathCode === '1' ? 'Virement instantané' : selectedOptionLien

        if (pathCode === '1' && !TransferData?.modeDePaiement) {
          setSelectedOptionLien(newSelectedOption)
          setPaymentMode('pi')
        }

        const currenciess = await getCurrencies()
        const idCurrenciess = await currenciess?.find((item: any) => item?.code === valuePays.value)
        if (setCounty) {
          setCounty(idCurrenciess?.country)
        }

        if (!idCurrenciess) {
          console.error('Devise de destination introuvable')
          return
        }
        const idSender = await currenciess?.filter(
          (item: any) => item?.countryCode === user?.user?.address?.country?.code,
        )
        // if(valuePays.value === TransferData?.valuePays) return

        const response = await CalculatorDetails(user?.user?._id, idCurrenciess.countryCode, pathTarnsfert, paymentMode)

        if (response) {
          setTaux(response.userFinancialDetails?.fxRate)
        }
        if (!idCurrenciess) {
          console.error('undefined1')
          return
        }

        if (!response || !response.userFinancialDetails) {
          console.error('Détails financiers non disponibles :', response)
          return
        }

        setIntervalComm(response.userFinancialDetails?.commissionDetails)

        setDestinationCurrencyId(idCurrenciess._id)
        setDepartureCurrencyId(idSender[0]._id)
        const cur = Math.round((euroValue * response.userFinancialDetails?.fxRate + Number.EPSILON) * 100) / 100
        const commVal = response.userFinancialDetails?.commissionDetails.find(
          (interval: intervalCommission) => euroValue >= interval.minAmount && euroValue <= interval.maxAmount,
        )
        //  setCom(commVal?.value ?? 0)
        setCom(successCode ? 0 : (commVal?.value ?? 0))
        if (response.isGift) {
          setCrossedOutValue(commVal.crossedOutValue)
        }
        setDinarValue(cur)

        //   setTransferData({
        //   ...TransferData,
        //   euroValue:euroValue,
        //   codeIso: payCode,
        //   valuePays: valuePays.value,
        //   amountToReceive: cur,
        //   selectedOptionLien: newSelectedOption,
        //   modeDePaiement: pathCode=== '1' ? 'pi' : paymentMode,

        // })

        if (TransferData?.valuePays !== valuePays.value && TransferData?.currentPath !== '/beneficiary') {
          setTransferData((prev: any) => ({
            ...(prev ?? {}), // ← si null, on repart d'un objet vide
            euroValue: euroValue,
            codeIso: payCode,
            valuePays: valuePays.value,
            amountToReceive: cur,
            selectedOptionLien: newSelectedOption,
            // modeDePaiement: pathCode === '1' ? 'pi' : paymentMode,
            modeDePaiement: paymentMode,

            BeneficiaryName: '',
            idBeneficiary: '',
            Motif: '',
            banqueName: '',
            numBankBeneficiary: '',
            phoneNumberBeneficiary: '',
            cinBeneficiary: '',
            avatar: '',
          }))
        } else {
          setTransferData((prev: any) => ({
            ...(prev ?? {}), // ← si null, on repart d'un objet vide
            euroValue: euroValue,
            codeIso: payCode,
            valuePays: valuePays.value,
            amountToReceive: cur,
            selectedOptionLien: newSelectedOption,
            // modeDePaiement: pathCode === '1' ? 'pi' : paymentMode,
            modeDePaiement: paymentMode,
          }))
        }
      } catch (error) {
        console.error(error)
      }
    }

    getDetailsUser()
  }, [valuePays, pathCode, paymentMode, payCode, promoCode])

  //  Un seul useEffect qui gère tout
  useEffect(() => {
    if (!taux) return

    try {
      if (isCalculDinar) {
        // Recalcul dinarValue + commission en même temps
        const cur = Math.round((euroValue * taux + isBonus * taux + Number.EPSILON) * 100) / 100

        if (intervalComm) {
          const commVal = intervalComm.find(
            (interval: intervalCommission) => euroValue >= interval.minAmount && euroValue <= interval.maxAmount,
          )

          // setCom(commVal?.value ?? 0)
          setCom(successCode ? 0 : (commVal?.value ?? 0))
          if (crossedOutValue !== 0) {
            setCrossedOutValue(commVal?.crossedOutValue ? commVal?.crossedOutValue : null)
          }
        }

        setDinarValue(cur)
        setCurrencyToTND(cur)
        handleEuroChangeMessage(euroValue)
      } else if (isCalculEuro) {
        const euroInputValue = Math.round((dinarValue / taux + Number.EPSILON) * 1000) / 1000 - isBonus
        if (intervalComm) {
          const commVal = intervalComm.find(
            (interval: intervalCommission) =>
              euroInputValue >= interval.minAmount && euroInputValue <= interval.maxAmount,
          )
          // setCom(commVal?.value ?? 0)
          setCom(successCode ? 0 : (commVal?.value ?? 0))
        }

        setEuroValue(euroInputValue)
        setCurrencyToTND(dinarValue)
        handleEuroChangeMessage(euroInputValue)
      }
    } catch (error) {
      console.log(error)
    }
    // dinarValue retiré des dépendances pour éviter la boucle
  }, [euroValue, taux, isBonus, successCode, intervalComm, isCalculDinar, isCalculEuro])

  useEffect(() => {
    const fetchData = async () => {
      if (!promoCode) return
      try {
        const response: any = await SearchPromoCodes({ promoCode: promoCode })
        if (response.success) {
          setSuccessCodeError(true)
          if (response?.success && response?.promos?.isBonus) {
            setIsBonus(response.promos.bonusValue)
          } else if (response.success && response.promos?.isCommission) {
          setSuccessCode(true)

          }
        } else {
          setIsBonus(0)
          setSuccessCode(false)
          setSuccessCodeError(false)
        }
      } catch (error) {
        console.log('err', error)
      }
    }
    if (promoCode.length === 10) fetchData()
    else {
      setSuccessCode(false)
      setIsBonus(0)
      setSuccessCodeError(false)

    }
  }, [promoCode])

  useEffect(() => {
    try {
      if (isCalculDinar) {
        const cur = parseFloat((euroValue * taux + isBonus * taux).toFixed(2))
        setDinarValue(cur)
        setCurrencyToTND(cur)
        handleEuroChangeMessage(euroValue)
      } else if (isCalculEuro) {
        const euroInputValue = Math.round((dinarValue / taux + Number.EPSILON) * 1000) / 1000 - isBonus
        setEuroValue(euroInputValue)
        setCurrencyToTND(dinarValue)
        handleEuroChangeMessage(euroInputValue)
      }
    } catch (error) {
      console.log(error)
    }
  }, [euroValue, dinarValue, paymentMode, successCode])

  const handleSelectedPaymentMode = (LienList: any) => {
    setIsOpenLien(false)
    setPaymentMode(LienList.code)
    setTransferData((prev: any) => ({
      ...(prev ?? {}),
      selectedOptionLien: LienList.value,
      modeDePaiement: LienList.code,
    }))
  }

  // useEffect(() => {
  //   setTransferData({
  //     ...TransferData,
  //     euroValue: euroValue,
  //     modeDePaiement: pathCode=== '1' ? 'pi' : paymentMode,
  //     amountToReceive: dinarValue,
  //     codeIso:payCode
  //   })
  // }, [euroValue, dinarValue, service, pathCode])

  return (
    <div className="flex flex-col w-full justify-between">
      <InputCalculateMontantEnvoyer
        crossedOutValue={crossedOutValue || null}
        euroValue={euroValue}
        com={com}
        taux={taux}
        setEuroValue={setEuroValue}
        error={error}
        handleEuroChange={handleEuroChange}
        number={number}
      />

      <ContainerTransfer
        dinarValue={dinarValue}
        handleDinarChange={handleDinarChange}
        setValuePays={setValuePays}
        valuePays={valuePays}
        number={number}
        service={service}
        setPaysCode={setPaysCode}
      />

      <InputSelectComponent
        liste={pathCode === '1' ? optionsLien.reverse() : optionsLien}
        isOpen={isOpenLien}
        setIsOpen={setIsOpenLien}
        value={selectedOptionLien}
        setValue={setSelectedOptionLien}
        label="Mode de paiement"
        handleClick={handleSelectedPaymentMode}
        // isDropDown={pathCode === '1' ? false : true}
        // isDesabled={pathCode==='1' ? true: false}
      />

      <div className="h-[130px] sm:h-[120px] flex flex-col  w-full mt-[20px] ">
        <div
          onClick={() => {
            setOpenCodePromotionnel(!openCodePromotionnel)
          }}
          className=" flex items-center justify-between cursor-pointer"
        >
          <label className="h3">Code Promotionnel</label>
          <img className={` ${openCodePromotionnel && 'rotate-45'}`} src={IconOpen} alt="code Promotionnel" />
        </div>
        {openCodePromotionnel && (
          <div>
            <input
              className={`text-[15px] outline-none text-[#35258B] px-4 mt-3 border border-[#AEB6FB] focus:border-[#5754E5] focus:text-[#5754E5] placeholder:text-[#D1D1FF] font-medium rounded-[14px] h-[56px] w-full `}
              placeholder="Code Promotionnel"
              type="text"
              value={promoCode}
              name="promoCode"
              onChange={handleChange}
              maxLength={10}
              autoComplete="no"
            />
            {successCodeError && promoCode.length === 10 ? (
              <div className="text-[#43B75D]  text-[14px]">Le code est valide</div>
            ) : (
              !successCodeError &&
              promoCode.length > 0 &&
              promoCode.length <= 10 && (
                <div className="text-[#EE443F]  text-[14px]">Veuillez entrer un code valide</div>
              )
            )}
          </div>
        )}
      </div>
      <button
        className={`font-bold font-roboto h-[56px] text-[#FFF]  rounded-[16px] w-full 
                ${error ? 'bg-[#D1D1FF] ' : 'bg-[#5754E5]  hover:bg-[#4D36CC]'}
                `}
        disabled={error}
        onClick={() => {
          setNumStep(1)
          functionTracks('1')
        }}
      >
        Suivant
      </button>
    </div>
  )
}
export default Montant
